import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import { teamMembers } from '../data';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import HeaderPage from '../components/HeaderPage';
import Footer from '../components/Footer';

function Team() {
	return (
		<>
			<Helmet>
				<title>Meet Your Host - Kamp Christy, Gull Lake MN</title>
				<meta name="description" content="Meet Kristy, your host at Kamp Christy on Upper Gull Lake. With 20+ years as a realtor, builder, and property manager, she ensures an unforgettable cabin experience." />
				<link rel="canonical" href="https://kampchristy.com/team" />
				<meta property="og:title" content="Meet Your Host - Kamp Christy" />
				<meta property="og:description" content="Meet Kristy, your host at Kamp Christy on Upper Gull Lake. 20+ years of hospitality experience." />
				<meta property="og:url" content="https://kampchristy.com/team" />
			</Helmet>

			<HeaderPage
				pageName={'Team'}
				subtitle={'a strong union'}
				icon={<FontAwesomeIcon icon={solid('users')} className="badge-icon" />}
			/>

			<motion.main
				className="container"

				initial={{ opacity: 0, y: '100%' }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: .8, ease: 'easeInOut' }}
				exit={{ opacity: 0, y: '100%' }}
			>
				<section className="txt-center">
					<h2>We take having fun seriously</h2>
					<h3 className="subtitle mb-2">Linked by passion</h3>

					<p className="mb-2"></p>

					{teamMembers.map((member, idx) =>
						<article className="team-card txt-left" key={idx}>
							<img src={member.img} className="team-photo rounded" alt={member.name} />
							<div className="team-info">
								<h3 className="subtitle">{member.role}</h3>
								<h2 className="mb-2">{member.name}</h2>
								<p className="mb-2">{member.text}</p>
								<p className="italic">" {member.cite} "</p>
							</div>
						</article>
					)}
				</section>
			</motion.main>

			<Footer />
		</>
	);
}

export default Team;